import styled from "styled-components";

export const FavouriteImage = styled.img<any>`
  cursor: pointer;
  margin-left: 8px;
`
